export default {
  club_name: 'Borås Basket',
  club_name_short: 'boras',
  stadium_name: '',
  staging_url: 'https://boras.api.fangroup.io',
  prod_url: 'https://boras.api.fangroup.io',
  api: '/api',
  facebook: 'https://www.facebook.com/BorasBasket/?locale=sv_SE',
  basename: '/boras',
  club_logo: '/assets/teams/boras.png',
  app_name: 'boras',
  websale_name: 'boras',
  ntb_team_id: 10042,
  microservice_url: 'https://stats.api.fangroup.io',
  currencyCaps: 'SEK',
  currencyShort: 'Kr',
  currencyShortSmall: 'kr',
  clubSportalityAvailable: false,
  leagueSportalityAvailable: false,
  cloudIdName: 'boras',
  monolithEnabled: false,
};
